








































import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class CheckDialog extends Vue {
  private visible = false;
  formData: any = {
    securityCheckTemplateId: '',
  };

  choiceList: any = [];
  data: any = [];
  private choiceThemeList: any = [];
  private checkItems: any = [];

  private async showDialog() {
    this.visible = true;
    this.getChoiceThemeList();
  }

  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange(val: any) {
    if (val) {
      this.choiceList = val;
    }
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    if (this.choiceList.length) {
      const sendForm: any = {
        ...this.formData,
        choiceList: this.choiceList.map((item: any) => {
          return { id: item.id, content: item.content };
        }),
      };
      this.$emit('getTemplateData', sendForm);
      this.visible = false;
    } else {
      this.$message.warning('请先选择检查内容项');
    }
  }

  private getChoiceThemeList() {
    performanceServer.getTemplateAll().then((res: any) => {
      if (res.code === '200') {
        this.choiceThemeList = res.data;
      } else {
        this.$message.warning(res.data.msg);
      }
    });
  }

  private changChoiceTheme(id: string) {
    performanceServer.getSingleTemplate(id).then((res: any) => {
      if (res.code === '200') {
        this.checkItems = res.data.checkItems && res.data.checkItems.length ? res.data.checkItems : [];
      }
      // console.log(this.checkItems,'wrewr');
      // const helpArr: any = []; // 处理后的表格数据 以替代 this.data
      // const helpArr1: any = [];
      // if (res.data.checkItems.length > 0) {
      //   res.data.checkItems.map(function(m: any) {
      //     // console.log(m);
      //     helpArr1.push({
      //       id: m.id, // id
      //       checkContent: m.content, // 检查内容
      //     });
      //   });
      // }
      // /*** SOLUTION ***/
      // this.data = helpArr;
      (this.$refs.multipleTable as any).toggleAllSelection(); // 默认的表格全选事件
    });
  }
}
